import image from '../../../../static/kingston-difference@large.jpg';

const key = 'the-kingston-difference';

export default {
  rootNavKey: [key],
  parentKeys: [key],
  image,
};
